document.addEventListener('DOMContentLoaded', () => {
  const productGrids = document.querySelectorAll('div[data-section-type="collection-grid"]')
  if (productGrids.length === 0) return;

  productGrids.forEach(grid => {
    const productCards = grid.querySelectorAll('.grid__item.grid-product')
    if (productCards.length === 0) return;

    productCards.forEach(card => {
      const swatches = card.querySelectorAll('a.color-swatch')
      const badgeWrapper = card.querySelector('.flex-inline')
      if (swatches.length === 0) return;

      const mainImageWrapper = card.querySelector('img[data-main-image]')
      const secondaryImageWrapper = card.querySelector('img[data-secondary-image]')

      swatches.forEach(swatch => {
        const mainImage = swatch.getAttribute('data-main-image')
        const secondImage = swatch.getAttribute('data-secondary-image')

        swatch.addEventListener('click', (e) => {
          e.preventDefault()

          // Remove any Old Badges
          const oldBadge = card.querySelector('.tagged-product')
          const oldBar = card.querySelector('.bar')
          if (oldBadge) oldBadge.remove()
          if (oldBar) oldBar.remove()

          // Update Badge Text
          const badgeText = swatch.getAttribute('data-badge-text')
          const badgeColor = swatch.getAttribute('data-badge-text-color')

          if (badgeText && badgeColor) {
            // console.log('xxx create badge', badgeText, badgeColor)
            const newBadge = document.createElement('div')
            newBadge.className = 'grid-product__vendor tagged-product'
            newBadge.style.color = badgeColor
            newBadge.innerText = badgeText
            const newBar = document.createElement('div')
            newBar.className = 'bar'
            newBar.innerText = '|'
            if (badgeWrapper) {
              badgeWrapper.prepend(newBar)
              badgeWrapper.prepend(newBadge)
            }
          }

          // Remove active class from any swatches
          swatches.forEach(swatch => {
            swatch.classList.remove('is-active')
          })

          // Add active class to new clicked swatch
          swatch.classList.add('is-active')

          mainImageWrapper.src = mainImage
          mainImageWrapper.setAttribute('srcset', `${mainImage}&width=360 360w, ${mainImage}&width=540 540w, ${mainImage}&width=720 720w, ${mainImage}&width=1000 1000w`)

          secondaryImageWrapper.src = secondImage
          secondaryImageWrapper.setAttribute('srcset', `${secondImage}&width=360 360w, ${secondImage}&width=540 540w, ${secondImage}&width=720 720w, ${secondImage}&width=1000 1000w`)
        })
      })
    })
  })
})